const HowItWorks = () => {
  const steps = [
    {
      num: '1',
      title: 'Complete your nomination',
      description: 'It takes just 10 minutes to share your company and founder details. Once submitted, our team will review your information and confirm your nomination via both email and phone call.',
      bgClass: 'bg-cyan-50 dark:bg-cyan-900/50',
      borderClass: 'border-cyan-200 dark:border-cyan-800',
      textColor: 'text-cyan-800 dark:text-cyan-200',
      descColor: 'text-cyan-700 dark:text-cyan-300',
      badgeBg: 'bg-cyan-500',
      arrowColor: 'text-cyan-500'
    },
    {
      num: '2',
      title: 'Shortlisting and payment',
      description: 'Startups are evaluated and shortlisted by the AQT Direct team and our investment partners. Selected startups will be notified through email or phone. Upon completing the payment, your participation is officially confirmed.',
      fee: 'Registration Fee: ₹4,99',
      bgClass: 'bg-blue-50 dark:bg-blue-900/50',
      borderClass: 'border-blue-200 dark:border-blue-800',
      textColor: 'text-blue-800 dark:text-blue-200',
      descColor: 'text-blue-700 dark:text-blue-300',
      badgeBg: 'bg-blue-500',
      arrowColor: 'text-blue-500'
    },
    {
      num: '3',
      title: 'Pitch Deck Preparation',
      description: "Whether you're a first-time founder or refining your pitch after past rejections, we'll help you build a compelling pitch deck that increases your chances of attracting investors.",
      bgClass: 'bg-purple-50 dark:bg-purple-900/50',
      borderClass: 'border-purple-200 dark:border-purple-800',
      textColor: 'text-purple-800 dark:text-purple-200',
      descColor: 'text-purple-700 dark:text-purple-300',
      badgeBg: 'bg-purple-500',
      arrowColor: 'text-purple-500'
    },
    {
      num: '4',
      title: 'Startup Pitch & Investor Interaction',
      description: 'Present your startup directly to investors, showcase your business idea, and receive real-time feedback. This session helps founders create genuine connections with investors and understand their expectations.',
      bgClass: 'bg-pink-50 dark:bg-pink-900/50',
      borderClass: 'border-pink-200 dark:border-pink-800',
      textColor: 'text-pink-800 dark:text-pink-200',
      descColor: 'text-pink-700 dark:text-pink-300',
      badgeBg: 'bg-pink-500',
      arrowColor: 'text-pink-500'
    }
  ];

  return (
    <section id="how-it-works" className="py-10 px-6 bg-secondary text-textPrimary">
      <div className="max-w-7xl mx-auto">
        
        {/* HEADING */}
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl font-bold text-primary mb-2">
            FROM APPLICATION TO PITCH — in 4 Steps
          </h1>
          <p className="text-lg text-textMuted">
            We help Founders to build what investors are really looking for:
          </p>
        </div>

        {/* STEPS GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className={`
                relative flex flex-col items-center text-center p-6 
                ${step.bgClass} 
                ${step.borderClass} 
                rounded-lg shadow-md border
                group hover:shadow-lg hover:-translate-y-1 transition-all duration-300
              `}
            >
              {/* STEP BADGE */}
              <div className={`
                absolute -top-6 w-12 h-12 flex items-center justify-center 
                ${step.badgeBg} 
                text-white rounded-full text-2xl font-bold 
                border-4 border-white dark:border-background-dark
                group-hover:scale-110 transition-transform duration-300
              `}>
                {step.num}
              </div>

              {/* CONTENT */}
              <div className="pt-8">
                <h2 className={`text-xl font-semibold mb-3 ${step.textColor}`}>
                  {step.title}
                </h2>
                <p className={`${step.descColor} leading-relaxed`}>
                  {step.description}
                </p>
                
                {/* FEE (only for step 2) */}
                {/* {step.fee && (
                  <p className="font-semibold mt-2 text-blue-600 dark:text-blue-400">
                    {step.fee}
                  </p>
                )} */}
              </div>

              {/* ARROW (hidden on mobile, only between steps) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute left-full top-1/2 -translate-y-1/2 ml-4">
                  
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FOOTNOTE */}
       <div className="mt-12 text-center p-4 border-t border-dashed border-gray-300 dark:border-gray-600">
  <p className="text-textMuted text-sm">
    Note: Startups selected for funding will receive a follow-up call within two days after the event for further process.
    <span className="block mt-1 text-xs italic">
      *Terms and conditions apply.
    </span>
  </p>
</div>

      </div>
    </section>
  );
};

export default HowItWorks;